// src/models/vendedorModel.js

import pb from '../lib/pocketbase';

export async function getClientes(page, perPage) {
  return await pb.collection('cliente').getList(page, perPage, {
    sort: '-created',
    $autoCancel: false,
  });
}

export async function createCliente(cliente) {
  return await pb.collection('cliente').create(cliente);
}

export async function updateCliente(id, cliente) {
  return await pb.collection('cliente').update(id, cliente);
}

export async function deleteCliente(id) {
  return await pb.collection('cliente').delete(id);
}


export async function getClienteAtributos(id = null) {
  try {
    const result = await pb.collection('atributo_cliente').getFullList({
      expand: 'cliente,atributo', // Expand the relationships
      filter: `cliente="${id}"`, // Correct filter syntax
    });

    // Transform the data
    const clienteAtributos = result.map((item) => {
      const cliente = item.expand.cliente;
      const atributo = item.expand.atributo;

      return {
        atributo: atributo,
        valor: item.valor,
      };
    });

    return clienteAtributos; // Optional: return the data for further use
  } catch (error) {
    console.error('Error retrieving data:', error);
  }
}